/* GRP UK search pop-up extras (snippets/search-popup.liquid):
   - compact header while typing (.is-typing hides the title and popular chips
     so the results get the space);
   - arrow keys move between suggestions, collections and products;
     Arrow Up from the first result returns to the search box. */
(function () {
  document.querySelectorAll('[data-search-popup]').forEach(function (popup) {
    if (popup.hasAttribute('data-grp-ux')) return;
    popup.setAttribute('data-grp-ux', '');
    var input = popup.querySelector('[data-search-input]');
    var panel = popup.querySelector('[data-search-results-panel]');
    if (!input) return;

    function sync() {
      popup.classList.toggle('is-typing', input.value.trim() !== '');
    }
    input.addEventListener('input', sync);
    var clear = input.form && input.form.querySelector('[data-clear-search]');
    if (clear) clear.addEventListener('click', function () { setTimeout(sync, 0); });

    function links() {
      if (!panel) return [];
      return Array.prototype.filter.call(panel.querySelectorAll('a[href], button[data-search-count]'), function (el) {
        return el.offsetParent !== null;
      });
    }

    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      var list = links();
      if (!list.length) return;
      e.preventDefault();
      list[0].focus();
    });

    if (panel) {
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var list = links();
        var i = list.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        if (e.key === 'ArrowDown') {
          (list[i + 1] || list[i]).focus();
        } else if (i === 0) {
          input.focus();
          var end = input.value.length;
          input.setSelectionRange(end, end);
        } else {
          list[i - 1].focus();
        }
        if (document.activeElement.scrollIntoView) document.activeElement.scrollIntoView({ block: 'nearest' });
      });
    }
    sync();
  });
})();
